import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    containerFeaturOverView: {
      width: "100%",
      padding: "24px",
      gap: "16px",
      display: "flex",
      flexDirection: "column",
    },
    containerHeader: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    containerBody: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    containerRow: {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      alignItems: "center",
      width: "100%",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
      },
    },
    containerItems: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      width: "100%",
      gap: "16px",
    },
  };
});
